window.flowURL = Shopify.shop.includes("thai")
  ? `https://rockher-thai-flow.evosem.com`
  : `https://rockher-flow.evosem.com`; //This is the URL of the flow server.
window.shopURL = Shopify.shop.includes("thai")
  ? `https://rockher-thai.myshopify.com`
  : `https://rockher-jewelry.myshopify.com`;

window.WishlistStorageKey = "wishlist_v3";
var MainRingBuilderStorageKey = "shop_ring_settings_v7";
var FrontAccessToken = Shopify.shop.includes("thai")
  ? "5c900b5b9162c2d0b9e496a49080a26f"
  : "a58e303e3ec7f32d1e622b5abed2bcb7";

var metalTypes = [
  // Rebrand: 14K moved to draft, redirected to 18K. Re-enable by uncommenting.
  // { shortcode: 'FW', value: '14KW', label: '14K White Gold' },
  {
    shortcode: "FR",
    value: "14KR",
    label: "14K Rose Gold",
  },
  {
    shortcode: "EW",
    value: "18KW",
    label: "18K White Gold",
  },
  // { shortcode: 'FY', value: '14KY', label: '14K Yellow Gold' },
  {
    shortcode: "EY",
    value: "18KY",
    label: "18K Yellow Gold",
  },
  {
    shortcode: "PT",
    value: "PL",
    label: "950 - Platinum",
  },
];
var shapesTypes = [
  {
    shortcode: "RD",
    value: "Round",
    label: "Round",
  },
  {
    shortcode: "OV",
    value: "Oval",
    label: "Oval",
  },
  {
    shortcode: "CU",
    value: "Cushion",
    label: "Cushion",
  },
  {
    shortcode: "PR",
    value: "Princess",
    label: "Princess",
  },
  {
    shortcode: "PS",
    value: "Pear",
    label: "Pear",
  },
  {
    shortcode: "EC",
    value: "Emerald",
    label: "Emerald",
  },
  {
    shortcode: "MQ",
    value: "Marquise",
    label: "Marquise",
  },
  {
    shortcode: "AS",
    value: "Asscher",
    label: "Asscher",
  },
  {
    shortcode: "RA",
    value: "Radiant",
    label: "Radiant",
  },
  {
    shortcode: "HS",
    value: "Heart",
    label: "Heart",
  },
];

window.diamondsCut = [
  {
    label: "fair",
    value: "FAIR",
    shortcode: "F",
  },
  {
    label: "good",
    value: "GOOD",
    shortcode: "G",
  },
  {
    label: "very good",
    value: "VERY GOOD",
    shortcode: "VG",
  },
  {
    label: "excellent",
    value: "EXCELLENT",
    shortcode: "EX",
  },
  {
    label: "ideal",
    value: "IDEAL",
    shortcode: "ID",
  },
];

window.diamondsFluorescences = [
  {
    label: "Very Strong",
    value: "VERY STRONG",
    shortcode: "VS",
  },
  {
    label: "Strong",
    value: "STRONG",
    shortcode: "S",
  },
  {
    label: "Medium",
    value: "MEDIUM",
    shortcode: "M",
  },
  {
    label: "Faint",
    value: "FAINT",
    shortcode: "F",
  },
  {
    label: "None",
    value: "NONE",
    shortcode: "N",
  },
];
window.diamondsSymmetry = [
  {
    label: "fair",
    value: "FAIR",
    shortcode: "F",
  },
  {
    label: "good",
    value: "GOOD",
    shortcode: "G",
  },
  {
    label: "very good",
    value: "VERY GOOD",
    shortcode: "VG",
  },
  {
    label: "excellent",
    value: "EXCELLENT",
    shortcode: "EX",
  },
];
window.diamondsPolish = [
  {
    label: "fair",
    value: "FAIR",
    shortcode: "F",
  },
  {
    label: "good",
    value: "GOOD",
    shortcode: "G",
  },
  {
    label: "very good",
    value: "VERY GOOD",
    shortcode: "VG",
  },
  {
    label: "excellent",
    value: "EXCELLENT",
    shortcode: "EX",
  },
  {
    label: "ideal",
    value: "IDEAL",
    shortcode: "ID",
  },
];

var shapesList = {
  round:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-round' stroke='currentColor' fill='currentColor'><path d='M24.2418 1.13343L24.6223 1.1367L24.2418 1.13343ZM24.6223 1.1367C37.3558 1.37517 47.4841 11.8889 47.2473 24.624C47.0104 37.3542 36.495 47.4842 23.7632 47.2457C11.0297 47.0105 0.899805 36.4951 1.13664 23.7633C1.3751 11.0298 11.8905 0.899866 24.624 1.1367H24.6223ZM17.5843 40.2322L8.5291 40.5572C12.6355 44.4982 18.079 46.7425 23.7697 46.8406H23.7877L17.5843 40.2322ZM30.8633 40.2044L24.6893 46.839C30.385 46.721 35.8255 44.4543 39.9201 40.4935L30.8633 40.2044ZM24.1879 37.4049L17.9355 40.0117L24.2369 46.7263L30.4958 40.0035L24.1879 37.4065V37.4049ZM8.58137 30.9777L8.289 40.157L17.4275 39.8304L14.806 33.542L8.58137 30.9777ZM39.8287 30.8895L33.5567 33.5028L30.9629 39.801L40.1586 40.095L39.8287 30.8895ZM1.54497 24.6877C1.66257 30.3839 3.92925 35.8251 7.89047 39.9202L8.17794 30.8617L1.5466 24.6877H1.54497ZM46.8406 24.5979L40.2321 30.798L40.5588 39.8532C44.4991 35.7472 46.7428 30.3042 46.8406 24.6142V24.5979ZM15.3385 33.7609L17.7852 39.6327L23.657 37.186L15.3385 33.7609ZM33.0258 33.7233L24.7203 37.1844L30.6036 39.6066L33.0258 33.7233ZM24.1356 11.3303L15.0804 15.1033L11.345 24.1749L15.118 33.2284L24.1895 36.9655L33.2431 33.1925L36.9801 24.1193L33.2071 15.0658L24.1356 11.3303ZM11.1261 24.7057L8.70387 30.589L14.5855 33.0112L11.1261 24.7057ZM37.2006 24.6518L33.7755 32.972L39.649 30.5236L37.2006 24.6518ZM8.3233 17.9813L1.65767 24.2369L8.3233 30.4436L10.904 24.1732L8.3233 17.9813ZM39.9936 17.8767L37.4195 24.121L40.0443 30.4175L46.7262 24.1455L39.992 17.8767H39.9936ZM7.82514 8.53243C3.88453 12.6384 1.64028 18.0813 1.5417 23.7714V23.7878L8.15017 17.5876L7.8235 8.53243H7.82514ZM40.4918 8.4671L40.2043 17.5239L46.8373 23.6979C46.7197 18.0017 44.453 12.5605 40.4918 8.46546V8.4671ZM14.5479 15.3271L8.6761 17.7722L11.1228 23.644L14.5479 15.3255V15.3271ZM33.738 15.2863L37.1974 23.5901L39.6196 17.7101L33.738 15.2863ZM8.22694 8.28906L8.55197 17.3818L14.7684 14.793L17.3279 8.57816L8.2253 8.28906H8.22694ZM40.0933 8.22536L30.9352 8.55203L33.5175 14.7538L39.8058 17.3443L40.0949 8.22536H40.0933ZM17.7215 8.68923L15.2993 14.5709L23.6048 11.1115L17.7231 8.68923H17.7215ZM30.5399 8.6631L24.6697 11.1098L32.9883 14.5349L30.5415 8.6631H30.5399ZM24.147 1.6561L17.9322 8.33643L24.1389 10.891L30.3749 8.29233L24.147 1.65773V1.6561ZM23.6962 1.54503C18.0006 1.66304 12.56 3.92969 8.4654 7.89053L17.5222 8.178L23.6962 1.54667V1.54503ZM24.6158 1.54503H24.5995L30.7996 8.15186L39.8564 7.8252C35.7504 3.88491 30.3074 1.64121 24.6174 1.5434L24.6158 1.54503Z' stroke-width='0.5'/></g></svg>",
  oval: "<svg viewBox='0 0 48 48'><g id='__evosem-shape-oval' stroke='currentColor' fill='currentColor'><path d='M24.29,.54c8.65,.24,15.5,10.95,15.34,23.89-.16,12.94-7.28,23.26-15.93,23.02-8.65-.24-15.5-10.95-15.34-23.89C8.52,10.62,15.64,.3,24.29,.54Zm10.14,40.25h-5.92l-4.12,6.24c3.87-.15,7.39-2.49,10.04-6.24h0Zm-14.95,0h-5.92c2.66,3.78,6.22,6.13,10.15,6.24h-.11l-4.12-6.24h0Zm4.52-2.78l-4.14,2.63,4.14,6.27,4.14-6.27-4.14-2.63Zm10.59-6.72l-4.2,2.67-1.73,6.42h5.93v-9.09Zm-21.19,0v9.09h5.93l-1.73-6.42-4.2-2.67Zm4.69,2.97l1.61,5.99,3.91-2.48-5.52-3.5h0Zm11.81,0l-5.52,3.5,3.91,2.48,1.61-5.99h0ZM8.75,24.56c.09,5.97,1.7,11.4,4.26,15.42v-8.97l-4.27-6.45h0Zm30.49,0l-4.26,6.45v8.97c2.57-4.04,4.19-9.5,4.26-15.55v.13Zm-15.25-14.15l-6.08,3.8-2.6,9.7,2.63,9.78,6.06,3.85,6.06-3.85,2.63-9.77-2.6-9.7-6.09-3.8h0Zm-8.89,14.25l-1.66,6.17,4,2.54-2.34-8.71h0Zm17.78,0l-2.34,8.71,4-2.53-1.66-6.17h0Zm-19.75-7.31l-4.36,6.53,4.36,6.59,1.76-6.57-1.76-6.56Zm21.71,0l-1.76,6.56,1.76,6.57,4.36-6.59-4.35-6.53Zm.13-9.34v8.82l4.26,6.39c-.13-5.89-1.73-11.23-4.26-15.2h0Zm-21.97,0c-2.57,4.04-4.19,9.5-4.26,15.55v-.35l4.26-6.39V8.02h0Zm4.41,6.5l-3.97,2.48,1.65,6.16,2.32-8.64Zm13.15,0l2.32,8.64,1.66-6.16-3.97-2.48h0Zm-11.29-6.91h-5.87v8.94l4.18-2.61,1.7-6.33Zm15.31,0h-5.87l1.7,6.33,4.18,2.61V7.61Zm-14.93,.09l-1.59,5.93,5.55-3.46-3.95-2.47Zm8.68,0l-3.96,2.47,5.55,3.46-1.59-5.93h0ZM24,1.08l-4.17,6.25,4.17,2.6,4.17-2.6L24,1.08Zm.4-.12l4.16,6.24h5.87c-2.66-3.78-6.22-6.13-10.15-6.24h.12Zm-.8,0c-3.87,.15-7.39,2.49-10.04,6.24h5.87L23.6,.96h0Z' stroke-width='0.5'></path></g></svg>",
  cushion:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-cushion' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M24.58,.54c2.79,0,5.09,.2,8.51,.84,9.44,1.76,14.36,7.07,14.36,17.17v10.9c0,10.09-4.93,15.4-14.36,17.17-3.18,.59-6.3,.84-9.1,.84h-.57c-2.78,0-5.09-.2-8.51-.84C5.47,44.85,.54,39.54,.54,29.45v-10.9C.54,8.46,5.47,3.15,14.91,1.38c3-.56,6.05-.84,9.1-.84h.57Zm-7.23,39.81l-11.79,1.59c2.03,1.88,4.74,3.17,8.1,3.96l.66,.15c.22,.05,.45,.09,.68,.13,3.39,.63,5.68,.82,8.44,.83h.14l-6.22-6.67h0Zm13.37-.03l-6.21,6.69h.09c2.6-.03,5.19-.27,7.75-.71l.68-.12c.23-.04,.45-.09,.68-.13l.66-.15c3.43-.81,6.17-2.14,8.22-4.08l-11.85-1.5Zm-6.69-6.61l-6.25,6.47,6.25,6.7,6.25-6.73-6.25-6.44h0Zm-15.82-2.71l-2.71,10.5,11.6-1.56-2.61-6.5-6.28-2.44ZM.98,24.29v5.16c0,5.31,1.38,9.25,4.08,12.02l2.73-10.62-.18-.07-.06-.29L.98,24.29Zm46.04-.09l-6.55,6.23-.06,.3-.18,.07,2.74,10.65c2.62-2.71,3.99-6.52,4.05-11.62v-5.63Zm-7.2,6.76l-6.31,2.5-2.55,6.47,11.54,1.46-2.68-10.43h0Zm-16.16,2.52H14.97l2.56,6.36,6.14-6.36Zm9.37,0h-8.63l6.14,6.33,2.49-6.33Zm.08-18.53H14.89v18.1h18.22V14.95ZM14.45,24.41l-6.31,6.04,.07,.07v.04l6.23,2.42v-8.57Zm19.09-.06v8.63l6.25-2.48v-.04l.08-.07-6.33-6.04ZM7.75,17.87L1.31,24l6.53,6.16,6.39-6.12-6.47-6.17Zm32.48-.07l-6.45,6.17,6.41,6.11,6.5-6.18-6.47-6.1ZM5.03,6.57C2.34,9.34,.98,13.27,.98,18.55v5.16l6.58-6.26,.03-.16,.21-.08L5.03,6.56h0ZM14.45,15.04l-6.39,2.53h0l6.39,6.1V15.04ZM42.69,6.28l-2.52,10.87,.21,.08,.03,.15,6.61,6.23v-5.07c0-5.47-1.46-9.48-4.33-12.27h0Zm-9.14,8.76v8.56l6.36-6.09-6.36-2.48h0ZM5.5,6.66l2.71,10.39,6.28-2.49,2.59-6.57-11.58-1.33Zm36.74-.38l-11.38,1.68,2.66,6.6,6.25,2.43,2.48-10.71Zm-24.78,1.93l-2.49,6.31h8.61l-6.12-6.31h0Zm13.02-.03l-6.12,6.34h8.68l-2.55-6.34h0ZM23.98,1.11l-6.32,6.69,6.3,6.5,6.3-6.52L23.98,1.11h0Zm-.48-.13c-2.86,.03-5.71,.31-8.52,.83-4.08,.76-7.29,2.19-9.6,4.4l11.89,1.37L23.51,.98h0Zm1.07,0h-.12l6.2,6.57,11.56-1.71c-2.28-2-5.35-3.31-9.2-4.03-3.39-.63-5.67-.82-8.44-.83Z' stroke-width='0.5'/></g></svg>",
  princess:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-princess' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M47.24,.53c.12,0,.23,.1,.23,.23V47.24c0,.12-.1,.23-.23,.23H.76c-.06,0-.12-.02-.16-.07-.04-.04-.07-.1-.07-.16V.76c0-.12,.1-.23,.23-.23H47.24Zm-6.62,40.41H7.38l-6.08,6.07H46.7l-6.07-6.07h0ZM.98,1.3V46.7l6.08-6.08V7.38L.98,1.3Zm46.04,0l-6.07,6.07V40.62l6.07,6.07V1.3Zm-13.44,32.59H14.42l-6.59,6.59H40.17l-6.59-6.59h0ZM7.51,7.83V40.17l6.59-6.59V14.42L7.51,7.83h0Zm32.98,0l-6.59,6.6v19.15l6.59,6.6V7.83h0Zm-7.05,6.72H14.55v18.89h18.89V14.56h0Zm6.73-7.05H7.83l6.59,6.59h19.15l6.59-6.59ZM46.7,.98H1.3L7.38,7.06H40.62L46.7,.98h0Z' stroke-width='0.5'/></g></svg>",
  emerald:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-emerald' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M35.81,.6l.15,.07,5.52,5.72,.06,.16V41.22l-.06,.16-5.75,5.96-.16,.07H12.19l-.15-.07-5.52-5.72-.06-.16V6.78l.06-.16L12.27,.67l.16-.07h23.39Zm-4.57,40.67h-14.61l-4,5.67h22.54l-3.92-5.67Zm-18.26-3.57l-5.96,3.79,5.15,5.33,4.06-5.75-3.25-3.37Zm22.05-.15l-3.39,3.52,3.98,5.75,5.37-5.56-5.95-3.7ZM6.89,7.18V41.05l5.9-3.75V10.82l-5.9-3.64Zm22.3,28.81h-10.38l-3.75,3.24,1.54,1.6h14.65l1.61-1.67-3.67-3.17ZM41.11,6.95l-5.9,3.75v26.44l5.9,3.67V6.95Zm-26.25,2.18l-1.63,1.69v26.51l1.52,1.58,3.84-3.31V12.34l-3.73-3.22Zm18.36-.07l-3.8,3.28v23.26l3.76,3.24,1.6-1.66V10.67l-1.56-1.61Zm-4.24,3.41h-9.95v23.07h9.95V12.46Zm2.42-5.29h-14.65l-1.58,1.63,3.71,3.21h10.23l3.8-3.28-1.51-1.56ZM12.37,1.2L7.02,6.74l5.97,3.68,3.4-3.53L12.37,1.2Zm23.46-.02l-4.06,5.75,3.25,3.37,5.96-3.79-5.15-5.33h0Zm-.45-.12H12.81l4,5.67h14.57l4-5.67Z' stroke-width='0.5'/></g></svg>",
  pear: "<svg viewBox='0 0 48 48'><g id='__evosem-shape-pear' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M24.23,.6c.08,.02,.14,.05,.24,.12l.12,.09,.16,.13,.54,.49,.52,.48,.27,.26,.56,.54c2.18,2.15,4.19,4.44,6.01,6.84l.5,.67,.06,.09v-.03c2.26,3.1,4.11,6.24,5.49,9.36l.31,.71,.21,.52c1.51,3.75,2.32,7.45,2.42,11.03v1.19c-.01,.65-.09,1.29-.21,1.93l-.11,.5-.07,.28c-1.75,6.7-8.91,11.58-17.25,11.58s-15.5-4.88-17.25-11.6l-.07-.29h0l-.08-.39-.05-.27s-.02-.05-.01-.08l.07,.35c-.13-.67-.21-1.34-.24-2.01v-1.19c.11-3.39,.84-6.89,2.2-10.43l.44-1.12,.04-.09c1.31-3.12,3.1-6.26,5.35-9.39l.45-.63-.02,.02,.1-.13,.2-.27c1.97-2.63,4.16-5.12,6.56-7.45l.53-.51,.51-.47,.74-.67c.09-.07,.19-.12,.3-.15h.47Zm-.47,39.31l-11.4,3.28c3.03,2.32,7.04,3.73,11.4,3.78v-7.06Zm.47,0v7.06h.11c4.32-.07,8.29-1.48,11.29-3.78l-11.4-3.28h0Zm16.72-4.88l-11.14,2.27,6.29,5.53c2.31-1.9,3.98-4.35,4.7-7.11l.08-.32,.08-.36Zm-33.9,.03l.08,.38c.68,2.87,2.38,5.42,4.76,7.38l6.28-5.52-11.14-2.27v.03Zm11.66,2.37l-5.91,5.2,10.6-3.04-4.69-2.15h0Zm10.58,0l-4.69,2.15,10.6,3.04-5.91-5.19Zm-5.52-22.24l-4.71,4.94-2.88,11.03,2.67,5.87,4.91,2.25V15.2h0Zm.46,0v24.08l4.91-2.25,2.68-5.87-2.88-11.03-4.71-4.94ZM15.81,31.46l-8.31,3.25,10.79,2.19-2.48-5.44h0Zm16.39,0l-2.48,5.44,10.78-2.19-8.3-3.25h0Zm6.75-10.01l-6.52,9.64,8.63,3.38c.07-.44,.11-.87,.12-1.31v-.67c-.02-3.52-.75-7.17-2.17-10.88l-.06-.15h0Zm-29.88,0l.17-.43c-1.49,3.7-2.29,7.36-2.39,10.9v.56l-.02,.11v.11c0,.59,.04,1.18,.13,1.77l8.63-3.38-6.52-9.63Zm9.49-1.18l-9.15,.88,6.43,9.51,2.71-10.38h0Zm10.91,0l2.71,10.38,6.43-9.5-9.14-.88Zm3.14-10.05l-3.13,9.63,9.19,.88v-.04l-.13-.28c-1.3-3.07-3.06-6.18-5.24-9.24l-.59-.82-.11-.14Zm-17.19,0l-.21,.29-.44,.61c-2.05,2.88-3.74,5.79-5.01,8.67l-.26,.62-.13,.32,9.19-.88-3.13-9.62h0Zm.52,.1l3.02,9.28,4.71-4.95-7.73-4.34Zm16.15,0l-7.72,4.34,4.71,4.94,3.01-9.28ZM23.77,1.08l-.71,.64-.5,.47c-.09,.08-.17,.16-.26,.25l-.54,.53c-.19,.18-.38,.37-.57,.57-1.86,1.88-3.59,3.85-5.18,5.91l-.24,.31,8,4.49V1.08h0Zm.46,0V14.24l8-4.49c-1.64-2.16-3.43-4.22-5.36-6.18l-.58-.58c-.19-.19-.38-.37-.56-.54l-.53-.5-.65-.59-.29-.25-.04-.03h0Z' stroke-width='0.5'/></g></svg>",
  marquise:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-marquise' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M24.7,.63l.22,.18,.3,.25,.17,.14c2.2,1.88,4.21,3.96,6.02,6.22,4.21,5.26,6.74,10.86,6.74,16.57,0,3.9-1.19,7.86-3.29,11.51l-.2,.35v.03c-.01,.13-.07,.25-.16,.34l-.06,.06c-1.72,2.86-3.85,5.5-6.15,7.85l-.33,.33-.33,.32-.32,.31-.48,.45-.45,.42-.42,.38-.38,.33-.34,.28-.28,.22-.15,.11-.12,.08c-.42,.32-.87,.34-1.3,.07l-.1-.07,.11-.15-.12,.14-.74-.62c-2.17-1.86-4.17-3.91-5.97-6.14-1.36-1.67-2.57-3.46-3.62-5.35l-.03-.03h0c-1.99-3.64-3.11-7.4-3.11-11.22C9.84,15.86,15.6,6.57,23.3,.62c.42-.31,.98-.28,1.41,0Zm5.04,29.91l-5.71,16.67c.13-.01,.25-.06,.35-.13l.2-.14,.14-.11,.08-.06,.19-.15,.33-.27,.25-.21,.41-.36,.44-.4,.46-.43,.32-.31,.48-.47,.32-.33c2.28-2.32,4.39-4.95,6.12-7.81,.09-.09,.13-.14,.13-.2v-.04l.03-.1,.15-.26-4.71-4.87Zm-11.65-.11l-4.67,4.83c1.01,1.78,2.17,3.48,3.46,5.07,1.7,2.11,3.58,4.06,5.62,5.83l.56,.48,.39,.33-5.37-16.54h0Zm.36-.18l5.34,16.45,5.47-15.98-4.83,3.44h-.22l-5.76-3.91Zm19.3-5.57l-7.77,5.53,4.68,4.84c1.86-3.31,2.96-6.86,3.09-10.38h0Zm-24.52,10.22l4.73-4.89-.04-.12-7.68-5.22c.12,3.48,1.18,6.9,2.99,10.23h0ZM24.19,14.25l-5.79,4.19-1.88,5.83,1.74,5.36,6.07,4.13,5.16-3.68,1.99-5.81-2-6.08-5.29-3.94Zm5.84,4.35l1.84,5.61v.13l-1.83,5.35,7.6-5.42-7.61-5.67Zm-12.17,.24l-7.5,5.43,7.36,5-1.6-4.93v-.12l1.74-5.38h0Zm-7.63,5.04l7.69-5.57-4.81-4.97c-1.8,3.5-2.86,7.13-2.88,10.55h0Zm24.56-10.72l-4.77,4.94,7.74,5.77v-.27c-.07-3.54-1.13-7.04-2.97-10.44ZM23.54,.94c-4.21,3.25-7.83,7.51-10.23,12.02l4.84,5L23.67,.86s-.09,.05-.13,.08h0Zm.4,.38l-5.33,16.49,5.47-3.96h.23l4.96,3.69L23.94,1.32h0Zm.25-.49l5.57,16.97,4.76-4.92,.24,.23c-1.05-1.92-2.27-3.74-3.65-5.44-1.79-2.23-3.79-4.3-5.97-6.16l-.32-.27-.35-.29c-.09-.06-.18-.1-.28-.13Z' stroke-width='0.5'/></g></svg>",
  asscher:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-asscher' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M41.5,.52l.16,.07,5.74,5.74,.07,.16V41.27l-.07,.16-5.98,5.97-.16,.07H6.5l-.16-.07L.59,41.67l-.07-.16V6.73l.07-.16L6.57,.59l.16-.07H41.5Zm-4.24,41.65H10.56l-3.6,4.85H40.82l-3.55-4.85h0Zm-30.96-4.22l-5.2,3.59,5.36,5.36,3.64-4.89-3.73-3.73-.07-.16v-.17h0Zm35.39-.18v.19l-.07,.16-3.9,3.9,3.57,4.87,5.6-5.59-5.19-3.53h0Zm-8.34-.95H14.54l-3.64,4.89h26.03l-3.58-4.89h0Zm2.94-2.72l-2.52,2.52,3.68,5.03,3.79-3.78v-.41l-4.95-3.37h0Zm-24.57,.11l-4.95,3.43v.39l3.62,3.61,3.74-5.03-2.41-2.41ZM.98,7.16V41.07l5.33-3.68V10.78L.98,7.16H.98Zm46.04-.23l-5.32,3.68v26.61l5.32,3.62V6.93ZM6.76,11.09v25.98l4.75-3.28V14.32l-4.75-3.23Zm34.48-.17l-4.75,3.28v19.47l4.75,3.23V10.93Zm-7.76,.71H14.63l-2.66,2.66v19.53l2.55,2.55h18.85l2.66-2.66V14.18l-2.55-2.55ZM10.55,6.35l-3.79,3.78v.41l4.95,3.36,2.52-2.52-3.68-5.04h0Zm27.07,.01l-3.74,5.03,2.41,2.41,4.95-3.42v-.39l-3.62-3.62Zm-.52-.07H11.07l3.58,4.89h18.81l3.64-4.89ZM6.71,1.1L1.11,6.69l5.2,3.53v-.19l.07-.16,3.9-3.9L6.71,1.1h0Zm34.82,0l-3.63,4.88,3.73,3.73,.07,.16v.17l5.2-3.59-5.36-5.36h0Zm-.48-.12H7.18l3.55,4.85h26.7l3.61-4.85h0Z' stroke-width='0.5'/></g></svg>",
  radiant:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-radiant' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M36.68,.43l.17,.07,5.93,5.76,.07,.16V41.34l-.07,.16-6.18,6-.17,.07H11.32l-.17-.07-5.93-5.76-.07-.16V6.66l.07-.16L11.39,.5l.17-.07h25.12Zm-4,42.28H15.14l-3.36,4.39h24.18l-3.29-4.39Zm-21.89-4.02l-5.02,2.92,5.52,5.37,3.42-4.48-3.92-3.81Zm26.42-.17l-4.1,3.98,3.35,4.47,5.76-5.6-5.02-2.85Zm-13.21-.11l-7.97,3.83h15.77l-7.81-3.83h0Zm7.25-1.03l-6.49,.89,7.68,3.77-1.2-4.66Zm-14.51,0l-1.35,4.66,7.82-3.76-6.47-.89Zm-.51,.06l-4.94,1.09,3.61,3.5,1.33-4.59Zm15.51-.01l1.18,4.6,3.76-3.65-4.94-.95ZM5.62,7.06V41.17l4.97-2.89V9.89l-4.97-2.82h0Zm36.76-.23l-4.97,2.89v28.39l4.97,2.82V6.83h0ZM15.09,25.18l-3.92,12.92,5.15-1.14-1.23-11.78Zm17.83,0l-1.23,11.78,5.15,.99-3.92-12.76h0Zm-8.72-15.12l-7.89,.63-.88,13.28,1.35,12.96,7.18,1,7.25-1,1.35-12.93-.68-13.31-7.69-.63Zm-13.14,1.27v25.48l3.89-12.82-3.89-12.67h0Zm25.87-.15l-3.89,12.82,3.89,12.67V11.18h0Zm-25.78-1.15l3.89,12.67,.79-12.02-4.68-.65h0Zm25.68-.15l-4.48,.79,.61,11.96,3.87-12.76ZM15.51,5.92l.78,4.32,7.05-.57-7.82-3.75Zm17.18,0l-7.64,3.75,6.87,.57,.77-4.31h0Zm-17.65,.06l-3.71,3.61,4.47,.62-.76-4.23Zm18.11,.02l-.75,4.19,4.28-.76-3.53-3.43Zm-1.14-.27h-15.8l7.99,3.83,7.81-3.83ZM11.53,1.02L5.77,6.61l5.02,2.85,4.1-3.98L11.53,1.02h0Zm25.18,0l-3.42,4.47,3.92,3.81,5.02-2.92-5.53-5.37h0Zm-.5-.12H12.03l3.29,4.39h17.54l3.36-4.39h0Z' stroke-width='0.5'/></g></svg>",
  heart:
    "<svg viewBox='0 0 48 48'><g id='__evosem-shape-heart' stroke='currentColor' fill='currentColor'><path xmlns='http://www.w3.org/2000/svg' d='M31.28,2.48c2.76-.77,5.09-.74,7.87-.02,3.31,.85,5.94,2.94,7.51,6.77,1.4,3.42,1.3,8.11,0,12.67-1.31,4.65-3.38,8.48-6.36,11.91-1.36,1.56-2.82,3.03-4.38,4.4l-.02,.26-.23,.19-.25-.03c-1.72,1.47-3.52,2.84-5.4,4.09-1.45,.96-2.94,1.85-4.48,2.65l-.52,.27-.47,.23-.47,.22h-.17l-.47-.22-.47-.23-.52-.27-.28-.15c-1.34-.71-2.76-1.55-4.21-2.51-1.88-1.25-3.69-2.62-5.41-4.09l-.25,.03-.22-.19-.02-.26c-1.55-1.37-3.02-2.84-4.38-4.4-2.98-3.43-5.05-7.25-6.36-11.91C.05,17.33-.06,12.65,1.35,9.23c1.57-3.83,4.2-5.92,7.51-6.77,2.78-.72,5.1-.75,7.87,.02,.71,.2,1.55,.5,2.48,.9,.45,.19,.92,.41,1.41,.63,.9,.42,1.78,.87,2.65,1.33l.73,.39,.35-.19,.58-.31c.81-.43,1.63-.83,2.45-1.22,.48-.23,.96-.44,1.41-.63,.81-.35,1.64-.66,2.48-.9h0Zm-3.18,35.41l-3.66,7.58,.4-.2,.51-.26,.27-.14c1.43-.76,2.82-1.59,4.17-2.49,1.76-1.17,3.45-2.44,5.07-3.8l-6.76-.69h0Zm-8.2,0l-6.76,.69c1.61,1.36,3.31,2.63,5.07,3.8,1.43,.96,2.92,1.83,4.44,2.63l.51,.26,.4,.2-3.66-7.58h0Zm4.17-2.76l-3.78,2.61,3.71,7.69,3.72-7.69-3.65-2.6Zm-12.09-5.6l.5,8.47,.23,.2,7.07-.72-1.33-6.55-6.47-1.4h0Zm24.05,0l-6.24,1.33-1.55,6.62,7.06,.72,.23-.2,.5-8.47Zm8.11-2.16l-7.69,2.06-.49,8.19c1.43-1.28,2.78-2.65,4.04-4.09,1.64-1.87,3.03-3.94,4.14-6.16h0Zm-40.26,0c1.11,2.22,2.5,4.29,4.14,6.16,1.26,1.44,2.61,2.81,4.03,4.09l-.49-8.18-7.68-2.07h0Zm25.41,3.83l-4.87,3.68,3.43,2.45,1.44-6.13h0Zm-10.36,.05l1.24,6.08,3.6-2.48-4.84-3.59Zm.22-17.9l-7.08,2.65,1.37,8.17,5.31,6.43,5.38,3.99,5.34-4.03,5.19-6.7,1.29-7.85-7.31-2.43-4.41,2.54h-.21l-4.87-2.78Zm-5.82,11.34l-1.31,4.44,6.06,1.32-4.75-5.75Zm21.41-.26l-4.62,5.95,5.87-1.25-1.26-4.7ZM7.91,20.25l-3.73,6.77,7.43,2,1.39-4.69-5.08-4.08h0Zm32.21,.08l-4.99,4,1.26,4.69,7.43-2-3.69-6.69Zm7.06-7.02l-6.76,6.65v.04l3.88,7.03c.72-1.48,1.32-3.06,1.83-4.74l.15-.5c.82-2.91,1.15-5.86,.92-8.48ZM.82,13.31c-.24,2.62,.09,5.57,.92,8.48,.53,1.88,1.18,3.62,1.97,5.25l3.89-7.06L.82,13.31Zm35.49,2.98l-1.24,7.57,4.91-3.93-3.67-3.64h0Zm-24.6,.07l-3.54,3.56,4.78,3.83-1.24-7.4h0Zm-.08-7.11L1.13,13.03l6.72,6.61,3.77-3.79v-6.6h0Zm24.88,.05l-.13,6.48,3.84,3.81,6.65-6.54-10.36-3.74h0Zm-12.39,2.55l-4.42,1.33,4.43,2.53,4.01-2.31-4.02-1.54Zm11.98-2.53l-6.98,3.98,6.86,2.28,.12-6.26Zm-24.06,0v6.25l6.64-2.49-6.64-3.76ZM31.33,3.01l-6.84,8.53,4.1,1.58,7.32-4.17-4.57-5.93Zm-14.65,0l-4.54,5.88,7.05,4,4.57-1.37L16.68,3.01Zm-10.48,.97c-1.9,1.11-3.42,2.86-4.47,5.41-.42,1.06-.7,2.17-.84,3.3l10.64-3.84L6.2,3.97Zm35.67,.04l-5.31,4.86,10.56,3.81c-.12-1.02-.37-2.03-.72-2.99l-.12-.3c-1.04-2.52-2.54-4.26-4.4-5.37Zm-11.12-.95c-.54,.18-1.15,.41-1.8,.69-.45,.19-.92,.4-1.4,.63-.82,.39-1.65,.8-2.43,1.21l-.58,.31-.45,.24h-.2l-.27-.15-.75-.4c-.8-.42-1.61-.83-2.43-1.22-.46-.22-.93-.43-1.4-.62-.65-.27-1.24-.5-1.78-.68l6.86,8.24L30.75,3.07Zm7.92-.3c-2.55-.61-4.72-.61-7.29,.11l.3-.08,4.51,5.85,5.3-4.85c-.69-.37-1.42-.66-2.18-.87l-.27-.07-.37-.09h0Zm-22.36,.03c-2.56-.67-4.74-.61-7.36,.06-.83,.21-1.62,.51-2.38,.91l5.27,4.82,4.47-5.79h0Z' stroke-width='0.5'/></g></svg>",
};

const queryUsdToThbRate = async () => {
  try {
    const cacheKey = "usdToThbRate";
    const cacheDuration = 30 * 60 * 1000; // 30 minutes
    const cache = localStorage.getItem(cacheKey);
    if (cache) {
      const cacheData = JSON.parse(cache);
      if (Date.now() - cacheData.timestamp < cacheDuration) {
        return parseFloat(cacheData.rate);
      }
    }

    const res = await fetch(
      "https://api.frankfurter.dev/v1/latest?base=USD&symbols=THB",
    );
    const data = await res.json();
    //Save the rate to cache for 30minutes
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        rate: data.rates.THB,
        timestamp: Date.now(),
      }),
    );

    return parseFloat(data.rates.THB);
  } catch (error) {
    console.error(error);
    return 0;
  }
};

Shopify.reverseConvertion = (amount) => {
  console.log("amount / Shopify.currency.rate");
  return amount / Shopify.currency.rate;
};

Shopify.currencySymbol = (currency, locale) => {
  return new Intl.NumberFormat(locale, { style: "currency", currency })
    .formatToParts(1)
    .find((x) => x.type === "currency").value;
};

Shopify.formatMoney = function (cents, format) {
  format = format || "${{amount}}";
  if (typeof cents == "string") cents = cents.replace(".", "");

  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  var defaultOption = (opt, def) => (typeof opt == "undefined" ? def : opt);

  var formatWithDelimiters = (number, precision, thousands, decimal) => {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  };

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  let _formatString = formatString
    .replace(placeholderRegex, value)
    .replace(".00", ""); //Remove unnecessary decimal format

  _formatString = _formatString.replace(
    "$",
    Shopify.currencySymbol(Shopify.currency.active, Shopify.locale),
  );

  return _formatString;
};

window.diamondQueryTemplate = `
	query (
		$filter: DiamondFilterInput
		$sort: DiamondSortInput
		$pageSize: Int
		$currentPage: Int
	) {
		diamondInventorySearch(
			filter: $filter
			sort: $sort
			pageSize: $pageSize
			currentPage: $currentPage
		) {
			total_count_all
			total_count
			page_size
			current_page
			items {
				carat
				clarity
				crown_angle
				culet
				cut
				depth
				diamond_video
				diamond_image
				diamondcolor
				dim_depth
				dim_length
				dim_width
				dimensions
				fancy_intensity
				fancycolor
				fluorescence
				gia_report_num
				girdle
				image
				is_fancy
				is_idealcut
				is_labgrown
				is_returnable
				lab
				name
				pavilion_angle
				polish
				price
				price_per_carat
				fprice
				qty
				ratio
				shape
				shipping_days
				sku
				small_image
				status
				symmetry
				tabl
				thumbnail
				url_key
				vendor
				vendor_stock_num
			}
		}
	}
`;

document.addEventListener(
  "DOMContentLoaded",
  (function () {
    (() => {
      const queryUsdToThbRate = async () => {
        try {
          const cacheKey = "usdToThbRate";
          const cacheDuration = 30 * 60 * 1000; // 30 minutes
          const cache = localStorage.getItem(cacheKey);
          if (cache) {
            const cacheData = JSON.parse(cache);
            if (Date.now() - cacheData.timestamp < cacheDuration) {
              return parseFloat(cacheData.rate);
            }
          }

          const res = await fetch(
            "https://api.frankfurter.dev/v1/latest?base=USD&symbols=THB",
          );
          const data = await res.json();
          //Save the rate to cache for 30minutes
          localStorage.setItem(
            cacheKey,
            JSON.stringify({
              rate: data.rates.THB,
              timestamp: Date.now(),
            }),
          );

          return parseFloat(data.rates.THB);
        } catch (error) {
          console.error(error);
          return 0;
        }
      };

      if (document.getElementById("MainRingBuilder")) {
        new Vue({
          delimiters: ["[[", "]]"],
          el: "#MainRingBuilder",
          data: {
            visibleMobile: false,
            is_inhouse_diamond: false,
            is_product_page: false,
            is_collection_page: false,
            is_diamondsearch_page: false,
            is_ringbuilder_page: false,
            selectedRing: null,
            selectedDiamond: null,
            selectedRingBuildSettings: null,
          },
          created: function () {
            this.is_diamondsearch_page =
              _rb_is_diamondsearch_page ||
              Boolean(document.getElementById("evosem-diamond-search"));
            this.is_ringbuilder_page = _rb_is_ringbuilder_page;
            this.is_inhouse_diamond = _rb_is_inhouse_diamond;
            this.is_product_page =
              _rb_is_available &&
              _rb_product &&
              _rb_product_collections.filter(
                (collection) =>
                  collection.handle ===
                  ("engagement-rings" || "build-an-engagement-ring"),
              ).length > 0; // if the product is in the collection engagement rings.

            this.is_collection_page =
              _rb_is_available &&
              _rb_current_collection &&
              (_rb_current_collection.handle === "engagement-rings" ||
                _rb_current_collection.handle === "build-an-engagement-ring" ||
                _rb_current_collection?.metafields?.enable_ring_builder);

            if (
              this.is_product_page &&
              document.querySelector(".product-form__quantity")
            ) {
              document.querySelector(".product-form__quantity").style.display =
                "none";
            }
          },
          mounted: async function () {
            if (Shopify.currency.active === "THB") {
              const usdToThbRate = await queryUsdToThbRate();
              Shopify.currency.rate = usdToThbRate;
            }

            this.loadRingSettings();
            this.listenOnLocalChanges();
          },
          methods: {
            rateConvertion: function (price) {
              return parseFloat(Shopify.currency.rate) * parseFloat(price);
            },

            clearSettings: function () {
              try {
                //Save to localstorage
                var setItemObjection = localStorage.setItem;
                localStorage.setItem = function (key, value) {
                  var event = new Event("ringbuilderstoragechange");
                  event.value = value;
                  event.key = key;
                  document.dispatchEvent(event);
                  setItemObjection.apply(this, arguments);
                };
                localStorage.setItem(MainRingBuilderStorageKey, "");
                return document
                  .createEvent("Event")
                  .initEvent("ringbuilderstoragechange", true, true);
              } catch (error) {
                return console.warn(error);
              }
            },

            clearRingBuilder: function ($event) {
              $event.preventDefault();
              var confirm = window.confirm(
                "Are you sure you want to clear the settings?",
              );
              if (!confirm) return;
              this.clearSettings();
              return (window.location = "/apps/diamondsearch");
            },

            toggleMobileView: function () {
              this.visibleMobile = !this.visibleMobile;
            },

            listenOnLocalChanges: function () {
              document.addEventListener(
                "ringbuilderstoragechange",
                ($event) => {
                  setTimeout(this.loadRingSettings, 500);
                },
                false,
              );
            },

            loadRingSettings: async function () {
              try {
                var ringBuilderData = this.getBuilderLocalStorageSettings();
                if (
                  ringBuilderData &&
                  ringBuilderData.ring &&
                  ringBuilderData.ring.variant &&
                  ringBuilderData.ring.product
                ) {
                  var _selectedRingVariant =
                    ringBuilderData.ring.product.variants
                      .filter(
                        (variant) =>
                          variant.id === ringBuilderData.ring.variant,
                      )
                      .reduce((t) => t);

                  this.selectedRing = {
                    variant: _selectedRingVariant,
                    price: parseFloat(_selectedRingVariant.price),
                    priceFormatted: Shopify.formatMoney(
                      _selectedRingVariant.price,
                      "${{amount}}",
                    ),
                    product: ringBuilderData.ring.product,
                    productImageSmall:
                      ringBuilderData.ring.product.media[0].preview_image.src +
                      "&width=80",
                  };
                }

                if (
                  ringBuilderData &&
                  ringBuilderData.diamond &&
                  ringBuilderData.diamond.carat &&
                  ringBuilderData.diamond.shape
                ) {
                  this.selectedDiamond = ringBuilderData.diamond;
                }

                if (
                  !_.isEmpty(this.selectedDiamond) &&
                  !_.isEmpty(this.selectedRing)
                ) {
                  this.selectedRingBuildSettings = {
                    total: Shopify.formatMoney(
                      parseFloat(this.selectedRing.price) +
                        parseFloat(
                          this.rateConvertion(
                            parseFloat(this.selectedDiamond.priceNumber),
                          ),
                        ),
                      "${{amount}}",
                    ),
                  };
                }
              } catch (error) {
                console.log(error);
              }
            },

            getBuilderLocalStorageSettings: function () {
              var shop_ring_settings = localStorage.getItem(
                MainRingBuilderStorageKey,
              );
              try {
                return JSON.parse(shop_ring_settings);
              } catch (error) {
                return false;
              }
            },
          },
        });
      }

      if (document.getElementById("MainRingBuilderBtn")) {
        new Vue({
          delimiters: ["[[", "]]"],
          el: "#MainRingBuilderBtn",
          data: {
            selectedRing: null,
            selectedDiamond: null,
            is_product_page: false,
            __is_available: false,
          },
          created: function () {},
          mounted: function () {
            this.is_product_page =
              _rb_is_available &&
              _rb_product &&
              _rb_product_collections.filter(
                (collection) => collection.handle === "engagement-rings",
              ).length > 0; // if the product is in the collection engagement rings.

            var builderLocalStorage = this.getBuilderLocalStorageSettings();
            if (
              !_.isEmpty(builderLocalStorage) &&
              !_.isEmpty(builderLocalStorage.diamond)
            )
              this.selectedDiamond = builderLocalStorage.diamond;
            if (!_.isEmpty(this.selectedDiamond)) {
              this.checkOnDiamond().then((response) => {
                this.selectedDiamond.__is_available = response;
              });
            }

            if (this.is_product_page) {
              if (
                document.querySelector(
                  ".product-form__buttons.product-btn-wish-wrap",
                )
              )
                document.querySelector(
                  ".product-form__buttons.product-btn-wish-wrap",
                ).style.display = "none";
            }
          },

          methods: {
            checkOnDiamond: function () {
              const query = window.diamondQueryTemplate;
              let variables = {
                pageSize: 1,
                filter: {
                  sku: this.selectedDiamond.sku,
                },
              };

              return fetch(`${window.apiBaseUrl}/graphql`, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: query,
                  variables: variables,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  return !_.isEmpty(
                    response?.data?.diamondInventorySearch?.items,
                  );
                })
                .catch((error) => {
                  console.warn(error);
                  return false;
                });
            },
            addRingToBuilder: function () {
              this.setRingLocalStorageSettings();
              if (_.isEmpty(this.selectedDiamond)) {
                // Rebrand: land on the diamond search pre-filtered to the shape
                // the customer chose on the setting page. A shape picked via the
                // note panel wins, otherwise the product's native center shape.
                var __rh_shape_path = "";
                try {
                  var __rh_shape = window.__rh_requested_shape || null;
                  if (
                    !__rh_shape &&
                    typeof product_global_metafields !== "undefined" &&
                    product_global_metafields &&
                    product_global_metafields.center_shape
                  ) {
                    var __rh_match = shapesTypes.filter(
                      (t) =>
                        t.shortcode === product_global_metafields.center_shape,
                    );
                    if (!_.isEmpty(__rh_match)) __rh_shape = __rh_match[0].value;
                  }
                  if (__rh_shape)
                    __rh_shape_path =
                      "/" + __rh_shape.toLowerCase().replace(/\s+/g, "-") + "-cut";
                } catch (error) {
                  __rh_shape_path = "";
                }
                return (window.location =
                  "/apps/diamondsearch" + __rh_shape_path);
              }
              return (window.location = "/pages/ringbuilder");
            },
            getBuilderLocalStorageSettings: function () {
              var shop_ring_settings = localStorage.getItem(
                MainRingBuilderStorageKey,
              );
              try {
                return JSON.parse(shop_ring_settings);
              } catch (error) {
                return false;
              }
            },
            setRingLocalStorageSettings: function () {
              var shop_ring_settings = this.getBuilderLocalStorageSettings(),
                selectedVariation = Number(
                  document.querySelector('input[name="id"]').value,
                );

              if (
                document.querySelector(
                  ".price__regular_discounted_percentage",
                ) &&
                document.querySelector(".price__regular_discounted") &&
                !_.isEmpty(
                  document.querySelector(
                    ".price__regular_discounted_percentage",
                  ).innerText,
                )
              ) {
                _rb_product.variants.map((variant) => {
                  variant.originalPrice = variant.price;
                  if (variant.id === selectedVariation) {
                    variant.price = parseFloat(
                      document
                        .querySelector(".price__regular_discounted")
                        .getAttribute("data-price"),
                    );
                    variant.discount = document.querySelector(
                      ".price__regular_discounted_percentage",
                    ).innerText;
                  }
                  return variant;
                });
              }
              var selectedRing = {
                product: _rb_product,
                variant: selectedVariation,
              };

              try {
                var _shop_ring_settings = shop_ring_settings;

                if (
                  !_shop_ring_settings ||
                  typeof _shop_ring_settings !== "object"
                ) {
                  _shop_ring_settings = {};
                }

                _shop_ring_settings.ring = selectedRing;

                //Save to localstorage
                var setItemObjection = localStorage.setItem;
                localStorage.setItem = function (key, value) {
                  var event = new Event("ringbuilderstoragechange");
                  event.value = value;
                  event.key = key;
                  document.dispatchEvent(event);
                  setItemObjection.apply(this, arguments);
                };
                localStorage.setItem(
                  MainRingBuilderStorageKey,
                  JSON.stringify(_shop_ring_settings),
                );
                return document
                  .createEvent("Event")
                  .initEvent("ringbuilderstoragechange", true, true);
              } catch (error) {
                return console.warn(error);
              }
            },
          },
        });
      }

      if (document.getElementById("MainRingBuilerPageReview")) {
        var MainRingBuilerPageReview = new Vue({
          delimiters: ["[[", "]]"],
          el: "#MainRingBuilerPageReview",
          data: {
            ready: false,
            addEngraving: false,
            addEngravingText: "",
            addEngravingFont: "modern",
            popboxes: {
              engravingInformation: false,
              engravingInspiration: false,
            },
            diamondExist: true,
            addingToCart: false,
            selectedRing: null,
            selectedDiamond: null,
            selectedRingBuildSettings: null,
            selectedRingFeaturedImage: null,
            selectedRingRealProduct: null,
            visibleRingSizesDropdown: false,
            linkCopied: false,
            itemsInCart: [],
          },
          created: function () {
            fetch(`/cart.js`, { method: "GET" })
              .then((response) => response.json())
              .then((response) => {
                this.itemsInCart = response.items;
              });
          },
          mounted: async function () {
            if (Shopify.currency.active === "THB") {
              const usdToThbRate = await queryUsdToThbRate();
              Shopify.currency.rate = usdToThbRate;
            }

            var queryString = window.location.search,
              urlParams = new URLSearchParams(queryString),
              setup = urlParams.get("setup"),
              preDefinedRing = urlParams.get("ring"),
              preDefinedDiamond = urlParams.get("diamond");

            if (!_.isEmpty(setup)) {
              try {
                fetch(`https://rockher-flow.evosem.com/shopify/share/setup/get`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: setup,
                  }),
                })
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status && response.data) {
                     var data = JSON.parse(
                        new TextDecoder().decode(
                          Uint8Array.from(atob(response.data), function (c) {
                            return c.charCodeAt(0);
                          })
                        )
                      );
                      if (data.diamond && data.ring) {
                        //Save to localstorage
                        var setItemObjection = localStorage.setItem;
                        localStorage.setItem = function (key, value) {
                          var event = new Event("ringbuilderstoragechange");
                          event.value = value;
                          event.key = key;
                          document.dispatchEvent(event);
                          setItemObjection.apply(this, arguments);
                        };
                        localStorage.setItem(
                          MainRingBuilderStorageKey,
                          JSON.stringify(data),
                        );
                        document
                          .createEvent("Event")
                          .initEvent("ringbuilderstoragechange", true, true);
                        this.loadRingSettings();
                        this.getProductFeaturedImage();
                        this.getRealProductData();
                      }
                    }
                  });
              } catch (error) {
                console.log(error);
              }
            } else {
              this.loadRingSettings();
              this.getProductFeaturedImage();
              this.getRealProductData();
            }

            setTimeout(async () => {
              if (!_.isEmpty(preDefinedRing) && !_.isEmpty(preDefinedDiamond)) {
                this.getDiamondBySku(preDefinedDiamond).then((res) => {
                  console.log(res);
                  res.priceNumber = res.price;
                  this.selectedDiamond = res;

                  this.selectedDiamond.media = {}; //Object of data
                  if (this.selectedDiamond.diamond_video) {
                    const match = this.selectedDiamond.diamond_video.match(
                      /^(https:\/\/loupe360\.com\/diamond\/[^/]+\/video\/)/,
                    );
                    if (match[0]) this.selectedDiamond.media.video = match[0];
                  }
                  if (!this.selectedDiamond.diamond_image) {
                    this.selectedDiamond.media.picture = `https://hermanos.rockher.com/static/frontend/Rockher/Winter/en_US/Rockher_Diamondsearch/images/diamondsearch/shapes/${this.selectedDiamond.shape.toLowerCase()}.jpg`;
                  } else {
                    this.selectedDiamond.media.picture =
                      this.selectedDiamond.diamond_image;
                  }
                  if (!this.selectedDiamond.fprice)
                    this.selectedDiamond.fprice =
                      this.selectedDiamond.price / 0.7;
                  if (!this.selectedDiamond.entity_id)
                    this.selectedDiamond.entity_id = this.selectedDiamond.sku;

                  fetch(`${window.flowURL}/shopify/product/miscellaneous/sku`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      sku: preDefinedRing,
                    }),
                  })
                    .then((response) => response.json())
                    .then(async (response) => {
                      if (response.status) {
                        this.selectedRing = {
                          // discount: "40% OFF",
                          product: response.result,
                          price: parseFloat(response.result.price),
                          priceFormatted: Shopify.formatMoney(
                            parseFloat(response.result.price),
                            "${{amount}}",
                          ),
                          productImageSmall: `${response.result.featured_image}&width=200`,

                          originalPrice: parseFloat(response.result.price),
                          originalPriceFormatted: Shopify.formatMoney(
                            parseFloat(response.result.price),
                            "${{amount}}",
                          ),
                        };
                        this.getRealProductData();
                        this.selectedRing.variant = response.result.variants[0];
                        this.selectedRingFeaturedImage = [
                          {
                            alt: null,
                            aspect_ratio: 1,
                            height: 1400,
                            media_type: "image",
                            src: `${response.result.featured_image}&width=300`,
                            width: 1400,
                          },
                        ];

                        this.selectedRingBuildSettings = {
                          total: Shopify.formatMoney(
                            parseFloat(this.selectedRing.price) +
                              parseFloat(
                                this.rateConvertion(
                                  parseFloat(this.selectedDiamond.priceNumber),
                                ),
                              ),
                            "${{amount}}",
                          ),
                        };
                      }
                    });
                });
              }
            }, 3000);
          },
          methods: {
            rateConvertion: function (price) {
              return parseFloat(Shopify.currency.rate) * parseFloat(price);
            },
            copyBuilderLink: function () {
              try {
                var ringBuilderData = this.getBuilderLocalStorageSettings();
                delete ringBuilderData.ring.product.content;
                delete ringBuilderData.ring.product.description;
                var ringBuilderDataEncoder = btoa(
                  String.fromCharCode(
                    ...new TextEncoder().encode(
                      JSON.stringify(ringBuilderData),
                    ),
                  ),
                );

                function fetchData() {
                  return fetch(`https://rockher-flow.evosem.com/shopify/share/setup`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      data: ringBuilderDataEncoder,
                    }),
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      if (!response.status) return;
                      var link = `${window.location.origin}/pages/ringbuilder?setup=${response.id}`;
                      return new Blob([link], { type: "text/plain" });
                    });
                }

                var clipboardItem = new ClipboardItem({
                  "text/plain": fetchData(),
                });
                navigator.clipboard
                  .write([clipboardItem])
                  .then(function () {
                    console.log("copied");
                  })
                  .catch(function (error) {
                    console.log(error);
                  });

                this.linkCopied = true;
                setTimeout(() => {
                  this.linkCopied = false;
                }, 1000);
              } catch (error) {
                console.log(error);
              }
            },

            closeDropBox: function (item) {
              this.popboxes[item] = false;
            },

            openDropBox: function (item, $event) {
              if ($event) $event.preventDefault();
              this.popboxes[item] = true;
            },

            addRecommendedEngraving: function ($event) {
              this.addEngravingText = $event.target.innerText;
              this.popboxes.engravingInspiration = false;
            },

            caretPosition: function () {
              try {
                var list = [
                    5.1, 6.4, 7.4, 8.1, 8.7, 9.1, 9.7, 10.2, 10.5, 17.9,
                  ],
                  goal = parseFloat(
                    _.head(this.selectedDiamond.dimensions.split("-")),
                  ),
                  common = list.reduce((prev, current) =>
                    Math.abs(goal - current) < Math.abs(goal - prev)
                      ? current
                      : prev,
                  ),
                  listIndex = list.indexOf(common) + 1,
                  positionPercent = (listIndex / list.length) * 100,
                  positionOffset = (100 - 100 / (common / goal)) / 2;

                return Math.max(
                  5,
                  Math.min(105, positionPercent - positionOffset),
                );
              } catch (errors) {
                console.log(errors);
                return null;
              }
            },

            getCutName: function (_value) {
              var item = diamondsCut.filter((i) => i.shortcode === _value);
              if (!_.isEmpty(item)) return item[0].label;

              return _value;
            },

            getFluorescencesName(_value) {
              const item = diamondsFluorescences.filter(
                (i) => i.shortcode === _value,
              );
              if (!_.isEmpty(item)) return item[0].label;

              return _value;
            },

            getPolishName(_value) {
              const item = diamondsPolish.filter((i) => i.shortcode === _value);
              if (!_.isEmpty(item)) return item[0].label;

              return _value;
            },

            getSymmetryName(_value) {
              const item = diamondsSymmetry.filter(
                (i) => i.shortcode === _value,
              );
              if (!_.isEmpty(item)) return item[0].label;

              return _value;
            },

            addToBag: function ($event) {
              $event.preventDefault();

              if (this.addingToCart) return;

              this.addingToCart = true;

              //If the type is an inhouse diamond.
              if (
                this.selectedDiamond.type == "Inhouse Labgrown Diamond" ||
                this.selectedDiamond.type == "Inhouse Natural Diamond"
              ) {
                // Skip the creation and add both products into cart
                var ringProperties = {
                  "Diamond SKU": this.selectedDiamond.sku,
                };

                if (this.addEngraving) {
                  ringProperties["Engraving"] = this.addEngravingText;
                  ringProperties["Engraving Style"] = this.addEngravingFont;
                }

                var diamondProperties = {};
                if (this.selectedDiamond.sku)
                  diamondProperties["SKU"] = this.selectedDiamond.sku;
                if (this.selectedDiamond.cut)
                  diamondProperties["Cut"] = this.selectedDiamond.cut;
                if (this.selectedDiamond.diamondcolor)
                  diamondProperties["Color"] =
                    this.selectedDiamond.diamondcolor;
                if (this.selectedDiamond.clarity)
                  diamondProperties["Clarity"] = this.selectedDiamond.clarity;
                if (this.selectedDiamond.lab)
                  diamondProperties["Lab"] = this.selectedDiamond.lab;
                if (this.selectedDiamond.gia_report_num)
                  diamondProperties["Certificate"] =
                    this.selectedDiamond.gia_report_num;
                if (this.selectedRing.variant.sku)
                  diamondProperties["Ring"] = this.selectedRing.variant.sku;

                //If the diamond exist in the card then remove it.
                var itemsToRemove = this.itemsInCart.filter(
                  (item) => item?.properties?.SKU === this.selectedDiamond.sku,
                );
                if (!_.isEmpty(itemsToRemove)) {
                  var updates = {};
                  for (var index = 0; index < itemsToRemove.length; index++) {
                    updates[itemsToRemove[index].variant_id] = 0;
                  }
                  fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      updates: updates,
                    }),
                  });
                }

                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: this.selectedRing?.variant?.id,
                        quantity: 1,
                        properties: ringProperties,
                      },
                      {
                        id: this.selectedDiamond.identifier,
                        quantity: 1,
                        properties: diamondProperties,
                      },
                    ],
                  }),
                })
                  .then((response) => response.json())
                  .then((response) => {
                    this.addingToCart = false;

                    var k_item_diamond = {
                        Name: `${parseFloat(this.selectedDiamond.carat).toFixed(2)} Carat ${this.selectedDiamond.shape} ${this.selectedDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`,
                        ProductID: this.selectedDiamond.sku,
                        Categories: [
                          `${this.selectedDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`,
                        ],
                        ImageURL: this.selectedDiamond?.media?.picture,
                        URL: `${this.selectedDiamond.carat}-carat-${this.selectedDiamond.shape}-diamond-${this.selectedDiamond.sku}`
                          .toLocaleLowerCase()
                          .replaceAll(".", "-"),
                        Brand: "Rockher",
                        Price: this.selectedDiamond.price,
                        CompareAtPrice: "$0",
                        $use_ip: true,
                        $is_session_activity: true,
                      },
                      k_item_product = {
                        Name: this.selectedRing.product.title,
                        ProductID: this.selectedRing.variant.id,
                        Categories: [
                          "Build an Engagement Ring",
                          "Engagement rings",
                        ],
                        ImageURL: `https:${this.selectedRing.product.featured_image}`,
                        URL: `https://${Shopify.shop}/${this.selectedRing.product.handle}`,
                        Brand: "Rockher",
                        Price: Shopify.formatMoney(
                          this.selectedRing.variant.price,
                        ),
                        CompareAtPrice: Shopify.formatMoney(
                          this.selectedRing.variant.compare_at_price,
                        ),
                        $use_ip: true,
                        $is_session_activity: true,
                      };

                    _learnq.push(["track", "Added to Cart", k_item_diamond]);
                    _learnq.push(["track", "Added to Cart", k_item_product]);

                    return (window.location = "/cart");
                  })
                  .catch((error) => {
                    console.log(error);
                    this.addingToCart = false;
                    return window.alert(
                      "Something went wrong please try again later.",
                    );
                  });

                return;
              }

              fetch(`${window.flowURL}/shopify/setup/creation`, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                  "x-requested-with": "XMLHttpRequest",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  stock_number: this.selectedDiamond?.sku,
                  ring_variant: this.selectedRing?.variant?.id,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  try {
                    if (!response.status) {
                      this.addingToCart = false;
                      return window.alert(response.error);
                    }

                    if (
                      !response?.shopifyCreate?.data?.productSet?.product
                        ?.variants
                    ) {
                      this.addingToCart = false;
                      return window.alert(
                        "Something went wrong please try again later.",
                      );
                    }

                    const variantId =
                      response?.shopifyCreate?.data?.productSet?.product
                        ?.variants?.edges[0].node?.legacyResourceId;

                    var diamondProperties = {};

                    if (this.selectedDiamond.sku)
                      diamondProperties["SKU"] = this.selectedDiamond.sku;
                    if (this.selectedDiamond.cut)
                      diamondProperties["Cut"] = this.selectedDiamond.cut;
                    if (this.selectedDiamond.diamondcolor)
                      diamondProperties["Color"] =
                        this.selectedDiamond.diamondcolor;
                    if (this.selectedDiamond.clarity)
                      diamondProperties["Clarity"] =
                        this.selectedDiamond.clarity;
                    if (this.selectedDiamond.lab)
                      diamondProperties["Lab"] = this.selectedDiamond.lab;
                    if (this.selectedDiamond.gia_report_num)
                      diamondProperties["Certificate"] =
                        this.selectedDiamond.gia_report_num;
                    if (this.selectedRing.variant.sku)
                      diamondProperties["Ring"] = this.selectedRing.variant.sku;

                    var ringProperties = {
                      "Diamond SKU": this.selectedDiamond.sku,
                    };

                    if (this.addEngraving) {
                      ringProperties["Engraving"] = this.addEngravingText;
                      ringProperties["Engraving Style"] = this.addEngravingFont;
                    }

                    //If the diamond exist in the card then remove it.
                    var itemsToRemove = this.itemsInCart.filter(
                      (item) =>
                        item?.properties?.SKU === this.selectedDiamond.sku,
                    );
                    if (!_.isEmpty(itemsToRemove)) {
                      var updates = {};
                      for (
                        var index = 0;
                        index < itemsToRemove.length;
                        index++
                      ) {
                        updates[itemsToRemove[index].variant_id] = 0;
                      }
                      fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          updates: updates,
                        }),
                      });
                    }

                    setTimeout(() => {
                      fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          items: [
                            {
                              id: this.selectedRing?.variant?.id,
                              quantity: 1,
                              properties: ringProperties,
                            },
                            {
                              id: parseInt(variantId),
                              quantity: 1,
                              properties: diamondProperties,
                            },
                          ],
                        }),
                      })
                        .then((response) => response.json())
                        .then((response) => {
                          this.addingToCart = false;

                          var k_item_diamond = {
                            Name: `${parseFloat(this.selectedDiamond.carat).toFixed(2)} Carat ${this.selectedDiamond.shape} ${this.selectedDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`,
                            ProductID: this.selectedDiamond.sku,
                            Categories: [
                              `${this.selectedDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`,
                            ],
                            ImageURL: this.selectedDiamond?.media?.picture,
                            URL: `${this.selectedDiamond.carat}-carat-${this.selectedDiamond.shape}-diamond-${this.selectedDiamond.sku}`
                              .toLocaleLowerCase()
                              .replaceAll(".", "-"),
                            Brand: "Rockher",
                            Price: this.selectedDiamond.price,
                            CompareAtPrice: "$0",
                            $use_ip: true,
                            $is_session_activity: true,
                          };

                          var k_item_product = {
                            Name: this.selectedRing.product.title,
                            ProductID: this.selectedRing.variant.id,
                            Categories: [
                              "Build an Engagement Ring",
                              "Engagement rings",
                            ],
                            ImageURL: `https:${this.selectedRing.product.featured_image}`,
                            URL: `https://${Shopify.shop}/${this.selectedRing.product.handle}`,
                            Brand: "Rockher",
                            Price: Shopify.formatMoney(
                              this.selectedRing.variant.price,
                            ),
                            CompareAtPrice: Shopify.formatMoney(
                              this.selectedRing.variant.compare_at_price,
                            ),
                            $use_ip: true,
                            $is_session_activity: true,
                          };

                          _learnq.push([
                            "track",
                            "Added to Cart",
                            k_item_diamond,
                          ]);
                          _learnq.push([
                            "track",
                            "Added to Cart",
                            k_item_product,
                          ]);

                          return (window.location = "/cart");
                        })
                        .catch((error) => {
                          console.log(error);
                          this.addingToCart = false;
                          return window.alert(
                            "Something went wrong please try again later.",
                          );
                        });
                    }, 3000);
                  } catch (error) {
                    console.log(error);
                    this.addingToCart = false;
                    return window.alert(
                      "Something went wrong please try again later.",
                    );
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            },

            toggleRingSizeDropDown: function ($event) {
              this.visibleRingSizesDropdown = !this.visibleRingSizesDropdown;
            },

            pickRingSize: function (value) {
              //Hide the options dropdown.
              this.visibleRingSizesDropdown = false;
              try {
                var selectedVariation = _.head(
                  this.selectedRingRealProduct?.variants?.edges.filter(
                    (variant) => variant.node.title === value,
                  ),
                );
                //Because the variation from the API is different must compromise the formatting
                this.selectedRing.variant = {
                  id: parseInt(
                    selectedVariation.node.id.replace(
                      "gid://shopify/ProductVariant/",
                      "",
                    ),
                  ),
                  title: selectedVariation.node.title,
                  option1: selectedVariation.node.title,
                  option2: null,
                  option3: null,
                  sku: selectedVariation.node.sku,
                  requires_shipping: selectedVariation.node.requires_shipping,
                  taxable: true,
                  featured_image: null,
                  available: selectedVariation.node.available,
                  name: `${this.selectedRing.product.title} ${selectedVariation.node.title}`,
                  public_title: selectedVariation.node.title,
                  options: [selectedVariation.node.title],
                  price: parseFloat(selectedVariation.node.price),
                  priceFormatted: Shopify.formatMoney(
                    selectedVariation.node.price,
                    "${{amount}}",
                  ),
                  originalPrice: parseFloat(selectedVariation.node.price),
                  originalPriceFormatted: Shopify.formatMoney(
                    selectedVariation.node.price,
                    "${{amount}}",
                  ),
                  weight: selectedVariation.node.weight,
                  compare_at_price: null,
                  inventory_management: "shopify",
                  barcode: null,
                };

                //Since this selected variant is different save it to the ring builder. easy!
                this.setRingLocalStorageSettings();
                this.loadRingSettings();
              } catch (error) {
                console.log(error);
              }
            },

            listenOnLocalChanges: function () {
              document.addEventListener(
                "ringbuilderstoragechange",
                ($event) => {
                  console.log("There is a change!");
                  setTimeout(this.loadRingSettings, 500);
                },
                false,
              );
            },

            loadRingSettings: async function () {
              try {
                var ringBuilderData = this.getBuilderLocalStorageSettings();
                if (_.isNull(ringBuilderData)) return (this.ready = true);

                if (
                  ringBuilderData &&
                  ringBuilderData.ring &&
                  ringBuilderData.ring.variant &&
                  ringBuilderData.ring.product
                ) {
                  var _selectedRingVariant =
                    ringBuilderData.ring.product.variants
                      .filter(
                        (variant) =>
                          variant.id === ringBuilderData.ring.variant,
                      )
                      .reduce((t) => t);

                  this.selectedRing = {
                    variant: _selectedRingVariant,
                    price: parseFloat(_selectedRingVariant.price),
                    priceFormatted: Shopify.formatMoney(
                      _selectedRingVariant.price,
                      "${{amount}}",
                    ),
                    product: ringBuilderData.ring.product,
                    productImageSmall:
                      ringBuilderData.ring.product.media[0].preview_image.src +
                      "&width=200",
                  };

                  if (!_.isEmpty(_selectedRingVariant.discount)) {
                    this.selectedRing.discount = _selectedRingVariant.discount;
                    this.selectedRing.originalPrice = parseFloat(
                      _selectedRingVariant.originalPrice,
                    );
                    this.selectedRing.originalPriceFormatted =
                      Shopify.formatMoney(
                        _selectedRingVariant.originalPrice,
                        "${{amount}}",
                      );
                  }

                  if (_.isEmpty(_selectedRingVariant.discount)) {
                    // this.selectedRing.discount = "40% OFF"
                    this.selectedRing.originalPrice = parseFloat(
                      _selectedRingVariant.price,
                    );
                    this.selectedRing.originalPriceFormatted =
                      Shopify.formatMoney(
                        _selectedRingVariant.price,
                        "${{amount}}",
                      );
                    this.selectedRing.price = parseFloat(
                      _selectedRingVariant.price,
                    );
                    this.selectedRing.priceFormatted = Shopify.formatMoney(
                      _selectedRingVariant.price,
                      "${{amount}}",
                    );
                  }
                }

                if (
                  ringBuilderData &&
                  ringBuilderData.diamond &&
                  ringBuilderData.diamond.carat &&
                  ringBuilderData.diamond.shape
                ) {
                  this.selectedDiamond = ringBuilderData.diamond;
                }

                if (
                  !_.isEmpty(this.selectedDiamond) &&
                  !_.isEmpty(this.selectedRing)
                ) {
                  this.selectedRingBuildSettings = {
                    total: Shopify.formatMoney(
                      parseFloat(this.selectedRing.price) +
                        parseFloat(
                          this.rateConvertion(
                            parseFloat(this.selectedDiamond.priceNumber),
                          ),
                        ),
                      "${{amount}}",
                    ),
                  };

                  this.getProductFeaturedImage();
                  return this.checkOnDiamond().then(() => {
                    return (this.ready = true);
                  });
                }

                return (this.ready = true);
              } catch (error) {
                console.log(error);
              }
            },

            getBuilderLocalStorageSettings: function () {
              var shop_ring_settings = localStorage.getItem(
                MainRingBuilderStorageKey,
              );
              try {
                return JSON.parse(shop_ring_settings);
              } catch (error) {
                return false;
              }
            },

            setRingLocalStorageSettings: function () {
              var shop_ring_settings = this.getBuilderLocalStorageSettings(),
                selectedRing = {
                  product: this.selectedRing.product,
                  variant: this.selectedRing.variant.id,
                };

              try {
                var _shop_ring_settings = shop_ring_settings;

                if (
                  !_shop_ring_settings ||
                  typeof _shop_ring_settings !== "object"
                ) {
                  _shop_ring_settings = {};
                }

                _shop_ring_settings.ring = selectedRing;

                //Save to localstorage
                var setItemObjection = localStorage.setItem;
                localStorage.setItem = function (key, value) {
                  var event = new Event("ringbuilderstoragechange");
                  event.value = value;
                  event.key = key;
                  document.dispatchEvent(event);
                  setItemObjection.apply(this, arguments);
                };
                localStorage.setItem(
                  MainRingBuilderStorageKey,
                  JSON.stringify(_shop_ring_settings),
                );
                return document
                  .createEvent("Event")
                  .initEvent("ringbuilderstoragechange", true, true);
              } catch (error) {
                return console.warn(error);
              }
            },

            getProductFeaturedImage: function () {
              try {
                if (!this.selectedRing?.product?.media) return false;
                this.selectedRingFeaturedImage =
                  this.selectedRing?.product?.media.filter(
                    (media) => media.media_type.toLowerCase() === "image",
                  );
              } catch (error) {
                console.log(error);
                return false;
              }
            },

            getRealProductData: function () {
              var query = `
								query ($handle: String!) {
									product(handle: $handle) {
										id
										title
										description(truncateAt: 200)
										descriptionHtml
										availableForSale
										createdAt
										updatedAt
										publishedAt
										handle
										onlineStoreUrl
										tags
										vendor
										productType
										totalInventory
										seo {
											description
											title
										}
										featuredImage { 
											id 
											height 
											width 
											altText 
											url(transform: { maxWidth: 300, maxHeight: 300 })  
										}
										priceRange {
											maxVariantPrice {
												amount
												currencyCode
											}
											minVariantPrice {
												amount
												currencyCode
											}
										}
										collections(first: 10) {
											edges {
												cursor
												node {
													id
													description(truncateAt: 200)
													descriptionHtml
													handle
													onlineStoreUrl
													title
													updatedAt
												}
											}
										}
										variants(first: 250) {
											edges {
												node {
													id
													available: availableForSale
													barcode
													currentlyNotInStock
													featured_image: image {
														url
													}
													quantityAvailable
													requires_shipping: requiresShipping
													sku
													title
													public_title: title
													weight
													selectedOptions {
														name
														value
													}
													price {
														amount
														currencyCode
													}
													unitPrice {
														amount
														currencyCode
													}
												}
											}
										}
										options(first: 250) {
											id
											name
											values
										}
										metafields(identifiers: [
											{namespace: "global", key: "3D_video_file_name"}
											{namespace: "global", key: "band_width"}
											{namespace: "global", key: "center_shape"}
											{namespace: "global", key: "center_shape_availability"}
											{namespace: "global", key: "center_stone_shape"}
											{namespace: "global", key: "class"}
											{namespace: "global", key: "collection_name"}
											{namespace: "global", key: "diamond_quality"}
											{namespace: "global", key: "diamond_total_weight"}
											{namespace: "global", key: "full_sku"}
											{namespace: "global", key: "item_subtype"}
											{namespace: "global", key: "item_type"}
											{namespace: "global", key: "metal_type"}
											{namespace: "global", key: "metal_type_shortcode"}
											{namespace: "global", key: "number_of_stones"}
											{namespace: "global", key: "parent_sku"}
											{namespace: "global", key: "parent_sku_suffix"}
											{namespace: "global", key: "primary_stone"}
											{namespace: "global", key: "ring_gender"}
											{namespace: "global", key: "setting_type"}
											{namespace: "global", key: "shipping_days"}
											{namespace: "global", key: "sub_class"}
											{namespace: "global", key: "sub_style"}
											{namespace: "global", key: "video"}
										]) {
											key
											value
										}
									}
								}
		
						`;

              var variables = {
                handle: this.selectedRing?.product?.handle,
              };

              fetch(`${window.shopURL}/api/2023-07/graphql.json`, {
                method: "POST",
                headers: {
                  "X-Shopify-Storefront-Access-Token": FrontAccessToken,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: query,
                  variables: variables,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  if (response?.data?.product) {
                    this.selectedRingRealProduct = response?.data?.product;
                    this.selectedRingRealProduct.RingSizes = _.head(
                      this.selectedRingRealProduct?.options.filter(
                        (option) => option.name === "Ring Size",
                      ),
                    );
                  }
                })
                .catch((error) => console.log(error));
            },

            checkOnDiamond: function () {
              const query = window.diamondQueryTemplate;
              let variables = {
                pageSize: 1,
                filter: {
                  sku: this.selectedDiamond.sku,
                },
              };

              return fetch(`${window.apiBaseUrl}/graphql`, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: query,
                  variables: variables,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  if (
                    _.isEmpty(response?.data?.diamondInventorySearch?.items)
                  ) {
                    this.diamondExist = false;
                    window.alert("Oups this diamond is no longer available");
                    return false;
                  }
                })
                .catch((error) => {
                  console.warn(error);
                  return false;
                });
            },

            getDiamondBySku: function (sku) {
              if (!sku) return false;

              const query = window.diamondQueryTemplate;
              let variables = {
                pageSize: 1,
                filter: {
                  sku,
                },
              };

              return fetch(`${window.apiBaseUrl}/graphql`, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: query,
                  variables: variables,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  if (_.isEmpty(response?.data?.diamondInventorySearch?.items))
                    return false;

                  return _.head(response?.data?.diamondInventorySearch?.items);
                })
                .catch((error) => {
                  console.warn(error);
                  return false;
                });
            },

            CartNoteChange: debounce(function ($event) {
              fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  note: $event.target.value,
                }),
              });
            }, 1000),
          },
        });
      }

      if (document.getElementById("wishlist-items")) {
        var _wishList = new Vue({
          delimiters: ["[[", "]]"],
          el: "#wishlist-items",
          data: {
            ready: false,
            loadedProducts: [],
            discounts: null,
          },
          created: function () {},
          mounted: function () {
            this.loadedProducts = this.getItems();
            this.ready = true;
          },
          methods: {
            getLocalStorage: function ($key) {
              return localStorage.getItem($key);
            },
            getStoredItems: function () {
              var wishlist = this.getLocalStorage(window.WishlistStorageKey);
              try {
                if (!wishlist) return false;
                wishlist = JSON.parse(wishlist);

                return wishlist;
              } catch (error) {
                console.log(error);
                return false;
              }
            },
            getItems: function () {
              try {
                return this.getStoredItems();
              } catch (error) {
                return [];
              }
            },
            removeFromWishlist: function (item) {
              var wishlist = localStorage.getItem(window.WishlistStorageKey);
              var wishlistArray = [];
              if (wishlist) {
                wishlistArray = JSON.parse(wishlist);
              }

              wishlistArray = wishlistArray.filter(
                (wishlist) => wishlist.id !== item.id,
              );
              localStorage.setItem(
                window.WishlistStorageKey,
                JSON.stringify(wishlistArray),
              );

              this.loadedProducts = this.getItems();
              return window.dispatchEvent(new CustomEvent("wishlistChanged"));
            },
          },
        });
      }
    })();

    (() => {
      //Add metal type variation if the product in builder.
      if (typeof product_in_builder !== "undefined") {
        var metalTypesList = $("#meta-types-list");
        if (metalTypesList) {
          if (!product_global_metafields.full_sku) return;

          try {
            fetch(`${window.apiBaseUrl}/rockhervariants/ajax/fetch`, {
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "x-requested-with": "XMLHttpRequest",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                sku: product_global_metafields.full_sku,
              }),
            })
              .then((response) => response.json())
              .then((request) => {
                if (!request.status) {
                  return console.warn(
                    "Unable to get product configuration bundle",
                  );
                }

                var listOfProduct = request.bundle
                  .map((items) =>
                    items.filter(
                      (item) =>
                        item.attribute_code === "center_shape_availability" &&
                        item.option_title ===
                          product_global_metafields.center_shape_availability,
                    ),
                  )
                  .filter((t) => !_.isEmpty(t))
                  .reduce((t) => t);
                var listOfProductMetals = request.bundle
                  .map((items) =>
                    items.filter(
                      (item) =>
                        item.attribute_code === "metal_type" &&
                        _.map(listOfProduct, "sku").includes(item.sku),
                    ),
                  )
                  .filter((t) => !_.isEmpty(t))
                  .reduce((t) => t);
                var listOfProductShapes = request.bundle
                  .map((items) =>
                    items.filter(
                      (item) =>
                        item.attribute_code === "center_shape_availability" &&
                        _.map(
                          request.bundle
                            .map((items) =>
                              items.filter(
                                (item) =>
                                  item.attribute_code === "metal_type" &&
                                  item.option_title ===
                                    product_global_metafields.metal_type,
                              ),
                            )
                            .filter((t) => !_.isEmpty(t))
                            .reduce((t) => t),
                          "sku",
                        ).includes(item.sku),
                    ),
                  )
                  .filter((t) => !_.isEmpty(t))
                  .reduce((t) => t);

                if (!_.isEmpty(listOfProductMetals)) {
                  metalTypes.forEach((type) => {
                    var link = listOfProductMetals.filter(
                      (product) => product.option_title === type.label,
                    );
                    if (!_.isEmpty(link)) {
                      $(".meta-types-list-wrapper").removeClass("hidden");
                      $("#meta-types-list").append(
                        `<li class="__metal-type-set __metal-type-set-${type.shortcode}  ${product_global_metafields.metal_type_shortcode === type.shortcode ? " active " : ""}"><a class="__evo-metal-${type.shortcode} __evo-metal-set" href="/products/${link[0].url_key}"></a></li>`,
                      );
                    }
                  });
                }

                if (!_.isEmpty(listOfProductShapes)) {
                  // Rebrand: render all 10 shapes. Shapes without a sibling SKU
                  // open an informational note instead of navigating.
                  $(".shape-types-list-wrapper").removeClass("hidden");

                  if (!document.getElementById("rh-shape-note-style")) {
                    $("head").append(
                      '<style id="rh-shape-note-style">' +
                        ".rh-shape-note{display:none;margin-top:10px;background:#fff;border:1px solid #e5e0d8;border-top:2px solid #b89b6a;padding:18px 40px 18px 18px;position:relative;}" +
                        ".rh-shape-note-close{position:absolute;top:8px;right:8px;background:none;border:0;color:#999088;font-family:Outfit,sans-serif;font-size:14px;line-height:1;padding:4px;cursor:pointer;}" +
                        ".rh-shape-note-eyebrow{font-family:Outfit,sans-serif;font-size:10px;letter-spacing:3px;text-transform:uppercase;color:#967a4a;margin-bottom:8px;}" +
                        ".rh-shape-note-text{font-family:Outfit,sans-serif;font-size:12px;font-weight:300;line-height:1.65;color:#666058;}" +
                        "</style>",
                    );
                  }

                  shapesTypes.forEach((type) => {
                    var link = listOfProductShapes.filter(
                      (product) => product.option_title === type.label,
                    );
                    var isActive =
                      product_global_metafields.center_shape === type.shortcode;
                    if (isActive) {
                      $(
                        ".shape-types-list-wrapper .product-shape-item-name",
                      ).text(type.value);
                      $(
                        "#shapes-types-list-dropdown .selected_value > div",
                      ).text(type.value);
                    }
                    if (!_.isEmpty(link)) {
                      $("#shape-diamonds").append(
                        `<div class="product-shape-item ${isActive ? " active " : ""}"><a class="__evo-shape-${type.shortcode} __evo-shape-set" href="/products/${link[0].url_key}">${type.label}</a></div>`,
                      );
                    } else {
                      $("#shape-diamonds").append(
                        `<div class="product-shape-item product-shape-item--novisual" data-shape-label="${type.label}"><a class="__evo-shape-${type.shortcode} __evo-shape-set" href="#" role="button">${type.label}</a></div>`,
                      );
                    }
                  });

                  if (!document.getElementById("rh-shape-note")) {
                    $("#shape-diamonds").after(
                      '<div id="rh-shape-note" class="rh-shape-note">' +
                        '<button type="button" class="rh-shape-note-close" aria-label="Close">&#10005;</button>' +
                        '<div class="rh-shape-note-eyebrow">About This Shape</div>' +
                        '<div class="rh-shape-note-text"></div>' +
                        "</div>",
                    );
                  }

                  $("#shape-diamonds").on(
                    "click",
                    ".product-shape-item--novisual a",
                    function ($event) {
                      $event.preventDefault();
                      var label = $(this).parent().attr("data-shape-label"),
                        lower = label.toLowerCase();
                      $("#shape-diamonds .product-shape-item").removeClass(
                        "active",
                      );
                      $(this).parent().addClass("active");
                      $(
                        ".shape-types-list-wrapper .product-shape-item-name",
                      ).text(label);
                      window.__rh_requested_shape = label;
                      $("#rh-shape-note .rh-shape-note-text").text(
                        "We have not photographed this design with a " +
                          lower +
                          " center yet, but you can choose a " +
                          lower +
                          " diamond as your center stone with complete confidence. Every ring is made to order, and after purchase you will receive a CAD rendering of your exact ring to review and approve before production begins.",
                      );
                      $("#rh-shape-note").show();
                    },
                  );

                  $(document).on(
                    "click",
                    "#rh-shape-note .rh-shape-note-close",
                    function () {
                      $("#rh-shape-note").hide();
                    },
                  );
                }

                return;
              });
          } catch (error) {
            console.log(error);
          }
        }
      }

      var EvosemDropDowns = document.querySelectorAll(
        "#evosem-dynamic-dropdown-ringsize",
      );
      EvosemDropDowns.forEach(($parent, index) => {
        var EvosemDropDownsLabel = $parent.querySelectorAll(".selected_value");
        EvosemDropDownsLabel.forEach(($childElement, index) => {
          $parent.querySelector(
            ".evosem-dynamic-dropdown-list-backdrop",
          ).onclick = ($_element) => {
            $parent
              .querySelector(".evosem-dynamic-dropdown-list")
              .classList.remove("active");
          };

          $childElement.onclick = ($element) => {
            $parent
              .querySelector(".evosem-dynamic-dropdown-list")
              .classList.toggle("active");
          };
        });
        var EvosemDropDownItems = $parent.querySelectorAll(
          ".evosem-dynamic-dropdown-list .dropdown-list-item",
        );
        EvosemDropDownItems.forEach(($childElement, index) => {
          $childElement.onclick = ($element) => {
            $parent.querySelector(".selected_value > div").innerText =
              $element.target.getAttribute("data-value");
            document
              .getElementById($element.target.getAttribute("data-for"))
              .click();
            $parent
              .querySelector(".evosem-dynamic-dropdown-list")
              .classList.remove("active");
          };
        });
      });
    })();

    (() => {
      fetch(`/cart.js`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          if (response?.items) {
            var items = response?.items.filter(
              (item) =>
                item.product_type === "Ring Setting" &&
                item?.properties &&
                item?.properties["Diamond SKU"],
            );

            if (!_.isEmpty(items)) {
              //Then check on each item's diamond.
              for (var i = items.length - 1; i >= 0; i--) {
                var item = items[i];
                var diamondSku = items[i].properties["Diamond SKU"];

                const query = window.diamondQueryTemplate;
                let variables = {
                  pageSize: 1,
                  filter: {
                    sku: diamondSku,
                  },
                };

                fetch(`${window.apiBaseUrl}/graphql`, {
                  method: "POST",
                  mode: "cors",
                  cache: "no-cache",
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    query: query,
                    variables: variables,
                  }),
                })
                  .then((response) => response.json())
                  .then((response) => {
                    if (
                      _.isEmpty(response?.data?.diamondInventorySearch?.items)
                    ) {
                      console.warn(`Invalid ring setting: ${item.id}`);
                      // Remove the item from cart.
                      var updates = {};
                      updates[item.id] = 0;
                      fetch(`/cart/update.js`, {
                        method: "POST",
                        headers: {
                          "x-requested-with": "XMLHttpRequest",
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          updates: updates,
                        }),
                      });

                      if (
                        !_.isEmpty(
                          document.getElementsByClassName(
                            `__cart-remove-item-${item.id}`,
                          ),
                        )
                      ) {
                        return document
                          .getElementsByClassName(
                            `__cart-remove-item-${item.id}`,
                          )[0]
                          .click();
                      }
                    }
                  })
                  .catch((error) => {
                    console.warn(error);
                  });
              }
            }
          }
        })
        .catch((error) => console.log(error));
    })();

    (() => {
      if (document.getElementById("single-product-wishlist")) {
        var wishlistButton = document.getElementById("single-product-wishlist"),
          wishlist = localStorage.getItem(window.WishlistStorageKey);

        var wishlistArray = [];
        if (wishlist) {
          wishlistArray = JSON.parse(wishlist);
        }

        if (wishlistButton) {
          var data = window.wishlistData.product;
          if (wishlistArray.filter((item) => item.id === data.id).length > 0)
            wishlistButton.classList.add("active");
        }

        document
          .getElementById("single-product-wishlist")
          .addEventListener("click", function ($event) {
            $event.preventDefault();
            var data = window.wishlistData.product,
              meta = window.wishlistData.meta,
              sku = window.wishlistData.sku,
              inbuilder = window.wishlistData.inbuilder,
              product = {
                id: data.id,
                sku: sku,
                collection_name: meta.collection_name,
                title: data.title,
                price: data.price,
                featured_image: data.featured_image,
                handle: data.handle,
                inbuilder: inbuilder,
                type: "product",
              };

            if (document.querySelector(".price__regular_discounted")) {
              product.price = Number(
                document
                  .querySelector(".price__regular_discounted")
                  .getAttribute("data-price"),
              );
              product.discount = {
                percentage: document.querySelector(
                  ".price__regular_discounted_percentage",
                ).innerText,
                regularPrice: data.price,
              };
            }

            var wishlist = localStorage.getItem(window.WishlistStorageKey);
            var wishlistArray = [];
            if (wishlist) {
              wishlistArray = JSON.parse(wishlist);
            }
            if (
              _.isEmpty(wishlistArray.filter((item) => item.id == product.id))
            ) {
              wishlistArray.push(product);
              this.classList.add("active");
            } else {
              this.classList.remove("active");
              wishlistArray = wishlistArray.filter(
                (item) => item.id !== product.id,
              );
            }
            localStorage.setItem(
              window.WishlistStorageKey,
              JSON.stringify(wishlistArray),
            );

            return window.dispatchEvent(new CustomEvent("wishlistChanged"));
          });
      }

      var initialiseWishlistCounter = () => {
        var wishlist = localStorage.getItem(window.WishlistStorageKey);
        if (!_.isEmpty(wishlist)) {
          try {
            var wishlistHeaderButton = document.getElementById(
              "wishlist-header-button",
            );
            wishlist = JSON.parse(wishlist);
            if (wishlist.length <= 0) {
              wishlistHeaderButton.classList.remove("active");
              wishlistHeaderButton.querySelector(
                ".wishlist-counter",
              ).innerText = 0;
              return;
            }
            wishlistHeaderButton.classList.add("active");
            wishlistHeaderButton.querySelector(".wishlist-counter").innerText =
              wishlist.length;
          } catch (error) {
            console.log(error);
          }
        }
      };

      initialiseWishlistCounter();

      window.addEventListener("wishlistChanged", () => {
        initialiseWishlistCounter(); //Reload wishlist counter.
      });
    })();

    (() => {
      var response = fetch(`${window.flowURL}/shopify/automaticdiscounts`, {
        method: "POST",
      })
        .then((response) => response.json())
        .then((response) => {
          window.discountsResponse = response;
          window.dispatchEvent(
            new CustomEvent("discount_loaded", {
              detail: response,
            }),
          );
        });
    })();

    (() => {
      if (document.getElementById("form-drop-hint")) {
        var sendingDropHint = false;
        var form = document.getElementById("form-drop-hint");
        form.addEventListener("submit", ($event) => {
          try {
            $event.preventDefault();
            $event.stopPropagation();
            var data = Object.fromEntries(new FormData(form));

            var dropHintEmail1 = data.dropHintEmail1,
              dropHintEmail2 = data.dropHintEmail2,
              dropHintFullName = data.dropHintFullName,
              dropHintEmail3 = data.dropHintEmail3,
              dropHintMessage = data.dropHintMessage,
              productId = data.productId,
              errors = [];

            if (sendingDropHint) return;

            if (_.isEmpty(dropHintEmail1))
              errors.push("Friend's Email Address is required");
            if (_.isEmpty(dropHintEmail3))
              errors.push("Your Email Address is required");
            if (_.isEmpty(dropHintMessage)) errors.push("Message is required");
            if (!_.isEmpty(errors)) return window.alert(errors);

            sendingDropHint = true;
            form
              .querySelector("#form-drop-hint-submit .loading-icon")
              .classList.remove("hidden");

            var request = fetch(`${window.flowURL}/shopify/drop-hint`, {
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "X-Shopify-Shop": Shopify.shop,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                name: dropHintFullName,
                email: dropHintEmail1,
                email1: dropHintEmail2,
                email2: dropHintEmail3,
                message: dropHintMessage,
                product: productId,
              }),
            })
              .then((res) => res.json())
              .then((res) => {
                sendingDropHint = false;
                form
                  .querySelector("#form-drop-hint-submit .loading-icon")
                  .classList.add("hidden");
                return document
                  .getElementById("drop-a-hint-modal")
                  .classList.add("hidden");
              })
              .catch((error) => {
                sendingDropHint = false;
                form
                  .querySelector("#form-drop-hint-submit .loading-icon")
                  .classList.add("hidden");
                console.warn(error);
              });
          } catch (error) {
            console.log(error);
          }
        });
      }
    })();

    (() => {
      if (document.getElementById("copy-product-link")) {
        var shareProductButton = document.getElementById("copy-product-link");
        shareProductButton.addEventListener("click", ($event) => {
          $event.preventDefault();
          var copyinglink = false;
          if (copyinglink) return false;
          var textElement = document.createElement("textarea");
          textElement.value = shareProductButton.getAttribute("data-url");
          document.body.appendChild(textElement);
          textElement.select();
          document.execCommand("copy");
          document.body.removeChild(textElement);
          copyinglink = true;
          return setTimeout(() => {
            copyinglink = false;
          }, 500);
        });
      }
    })();
  })(),
  false,
);

(() => {
  $(document).ready(function ($) {
    //passive listeners to improve scrolling
    jQuery.event.special.touchstart = {
      setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {
          passive: !ns.includes("noPreventDefault"),
        });
      },
    };
    jQuery.event.special.touchmove = {
      setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {
          passive: !ns.includes("noPreventDefault"),
        });
      },
    };
    jQuery.event.special.wheel = {
      setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
      },
    };
    jQuery.event.special.mousewheel = {
      setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
      },
    };

    if ($.fn.slick) {
      $(".slick-it-slider-small").slick({
        prevArrow:
          '<button class="nav-arrows prev-arrow"><svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/></svg></button>',
        nextArrow:
          '<button class="nav-arrows next-arrow"><svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg></button>',
      });
    }

    $(".tooltip-rh-button").on("click", function () {
      var target = $(this).data("target");
      $(target).toggleClass("hidden");
    });

    $(".rh-modal-screen .close-modal").click(function () {
      $(this).parents(".rh-modal-screen").addClass("hidden");
    });

    $(".rh-modal-screen").click(function ($element) {
      if ($element.target === this) {
        $(this).addClass("hidden");
      }
    });

    $(".footer-mobile-collapsible-view .footer-block__heading").click(
      function () {
        $(this)
          .parents(".footer-mobile-collapsible-view")
          .toggleClass("active");
      },
    );
  });
})();